export default __webpack_public_path__ + "static/avatar-simon-james-aee5b3e846710f3ba8ac9e89bde43cf5.webp";